import { FC, ChangeEvent, MouseEvent } from 'react'
import {
    SelectChip,
    SelectStacked,
    SelectInput,
    SelectBox,
    SelectText,
    CheckboxTooltip,
} from './select-checkbox-styles'

interface Props {
    id: string
    checked: boolean
    label: string
    layout?: 'chip' | 'stacked'
    disabled?: boolean
    // Shown on hover/focus only while `disabled` — explains why selection isn't available right now.
    disabledTooltip?: string
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
    onClick?: (event: MouseEvent) => void
}

const SelectCheckbox: FC<Props> = ({
    id,
    checked,
    label,
    layout = 'chip',
    disabled = false,
    disabledTooltip,
    onChange,
    onClick,
}) => {
    const Container = layout === 'stacked' ? SelectStacked : SelectChip

    return (
        <Container htmlFor={id} $disabled={disabled} onClick={onClick}>
            <SelectInput id={id} type="checkbox" checked={checked} disabled={disabled} onChange={onChange} />
            <SelectBox $disabled={disabled} />
            <SelectText $disabled={disabled}>{label}</SelectText>
            {disabled && disabledTooltip && <CheckboxTooltip role="tooltip">{disabledTooltip}</CheckboxTooltip>}
        </Container>
    )
}

export default SelectCheckbox
